import { uniq } from 'lodash';

const splitDelimitedString = emailListStr =>
  uniq(emailListStr.split(/[,;]+/).map(email => email.trim()));

export default splitDelimitedString;
